import {ContentListService} from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {   
    getEmailTemplateOptions(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getEmailTemplateOptions,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getContentList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getContentList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    getAllContentList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getAllContentList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    
    submitReview(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.submitReview,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    submitReviews(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.submitReviews,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getMiniProgList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getMiniProgList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getExpandContentList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getExpandContentList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    addContent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.addContent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },addEmailContent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.addEmailContent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
    delContent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.delContent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    updateContent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.updContent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },updEmailContent(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.updEmailContent,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    getContentById(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getContentById,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

     getContentDictList(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getContentDictList,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    // getSMSList(vue, query) {
    //     return new Promise((resolve, reject) => {
    //         let requestModel = new RequestModel({
    //                 method: 'get',
    //                 url: ContentListService.getSMSList,
    //                 data: query.data ? query.data : {},
    //                 params: query.params ? query.params : {}
    //             }),
    //             request = requestModel.defaultConfig();
    //         vue.axios(request).then(function (result) {
    //             resolve(result);
    //         })
    //     });
    // },
    getWeComSender(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: ContentListService.getWeComSender,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {}
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    saveContentDict(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.saveContentDict,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },

    ContentIsUse(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: ContentListService.contentIsUse,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }),
                request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}